module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "排班管理",
      "name": "settingMange"
    }
  }, [_c('work-shift', {
    attrs: {
      "is-load": _vm.settingMangeLoad,
      "shop-list-data": _vm.shopListData,
      "resource-name": _vm.resourceName
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.resourceName + '列表',
      "name": "reservationModel"
    }
  }, [_c('resource-list', {
    ref: "resource",
    attrs: {
      "is-load": _vm.resouceLoad,
      "shop-list-data": _vm.shopListData,
      "resource-name": _vm.resourceName
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0a781e8c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a781e8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/reservation/resourcesetting/index.vue
// module id = 2451
// module chunks = 0